module.exports = __webpack_public_path__ + "static/img/preview-03.a1afb128.webp";